import { z } from 'zod';

export const templateReferenceV1Schema = z
  .object({
    // undefined if choose itself
    templateId: z.string().optional(),
    field: z.string().min(1),
    fieldName: z.string(),
  })
  .optional();

export type TemplateReferenceV1 = z.infer<typeof templateReferenceV1Schema>;
